import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
  Spinner
} from '@material-tailwind/react'
import CustomSelect from '../../custom-select'
import { FileInput } from '../../file-input'
import { FiZap } from 'react-icons/fi'
import { useState, useMemo } from 'react'
import { importServices } from '@/services'
import { NotificationModal } from '@/components/notification-modal'

export const DataUploadModal = (props) => {
  const [selectedModule, setSelectedModule] = useState([])
  const [uploadedFile, setUploadedFile] = useState([])
  const [showNotificationModal, setShowNotificationModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [iconTypeNotificacionModal, setIconTypeNotificacionModal] = useState('')
  const [titleNotificacionModal, setTitleNotificationModal] = useState('')
  const [messageNotificacionModal, setMessageNotificationModal] = useState('')

  const moduleOptions = useMemo(() => {
    return [
      { value: 'contractors', label: 'Contratistas' },
      { value: 'contracts', label: 'Contratos' },
      { value: 'employees', label: 'Personas' },
      { value: 'assets', label: 'Activos' }
    ]
  }, [])

  const exportCsvInfo = (errors) => {
    const fileData = errors.join('\n')
    const blob = new Blob([fileData], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.download = `resultado_importacion_${selectedModule?.label?.toLowerCase()}.csv`
    link.href = url
    link.click()
  }

  const validateImportResponse = (response) => {
    const errors = response?.data?.errors
    const csvSize = response?.data?.csv_size
    exportCsvInfo(errors)

    if (errors.length === 0) {
      setIconTypeNotificacionModal('check')
      setTitleNotificationModal('Importación realizada exitosamente.')
      setMessageNotificationModal(
        `Se importaron correctamente todos los datos de ${selectedModule?.label}`
      )
    } else if (errors?.length < csvSize) {
      setIconTypeNotificacionModal('danger')
      setTitleNotificationModal('Importación realizada parcialmente.')
      setMessageNotificationModal(
        'Se importaron correctamente algunos datos de Contratistas. Se descargará automáticamente un archivo con el detalle.'
      )
    } else if (errors?.length === csvSize) {
      setIconTypeNotificacionModal('error')
      setTitleNotificationModal('No se pudieron importar los datos.')
      setMessageNotificationModal(
        'No se pudieron importar los datos del archivo cargado. Verifica que el formato del archivo sea correcto y que los campos obligatorios se estén cumpliendo.'
      )
    }
    setIsLoading(false)
    setShowNotificationModal(true)
  }

  const uploadFile = () => {
    if (selectedModule.length === 0) return
    setIsLoading(true)
    importServices
      .sendFile({
        body: {
          file: uploadedFile
        },
        type: selectedModule.value
      })
      .then((response) => {
        validateImportResponse(response)
        console.log(response.data)
      })
  }

  return showNotificationModal ? (
    <NotificationModal
      title={titleNotificacionModal}
      message={messageNotificacionModal}
      iconType={iconTypeNotificacionModal}
      setBackStateFunction={setShowNotificationModal}
    ></NotificationModal>
  ) : (
    <Dialog {...props}>
      <DialogHeader className='flex flex-col items-start'>
        <div className='flex justify-center items-center w-14 h-14 bg-blue-50 border-blue-50 p-3 rounded-[28px] text-blue-900 mb-4'>
          <div className='flex items-center justify-center bg-blue-100 rounded-[28px] p-3 w-10 h-10'>
            <FiZap size='2rem' className='text-blue-600' />
          </div>
        </div>
        <Typography variant='h5' className='text-black'>
          Módulo de importación masiva
        </Typography>
        <Typography variant='small' className='text-gray-500'>
          En este modal puedes cargar masivamente datos a los módulos de
          Contratos, Contratistas, Personas y Activos.
        </Typography>
      </DialogHeader>
      {isLoading ? (
        <div className='p-10'>
          <div className='grid justify-center '>
            <Spinner className='w-20 h-20 m-5' color='blue' />
          </div>
          <div className='grid justify-center'>
            <Typography variant='small' className='text-gray-500'>
              Realizando importación masiva del modulo {selectedModule?.label}.
              No cerrar esta ventana
            </Typography>
          </div>
        </div>
      ) : (
        <div>
          <DialogBody className='flex flex-col gap-4'>
            <div className='flex flex-col'>
              <CustomSelect
                options={moduleOptions}
                value={selectedModule}
                onChange={(option) => setSelectedModule(option)}
                placeholder='Seleccione el módulo'
              />
              {selectedModule.length !== 0 ? (
                <Typography variant='small' className='mt-2'>
                  Descarga el{' '}
                  <a
                    className='text-blue-600 underline'
                    href={`/csv-templates/${selectedModule?.label?.toLowerCase()}_plantilla.csv`}
                  >
                    formato de esta plantilla
                  </a>
                </Typography>
              ) : (
                <></>
              )}
            </div>
            <FileInput
              value={uploadedFile}
              handleChange={(file) => setUploadedFile(file)}
            />
          </DialogBody>
        </div>
      )}
      <DialogFooter className='flex justify-between'>
        <Button
          variant='outlined'
          color='white'
          onClick={props.handler}
          disabled={isLoading}
        >
          Cancelar
        </Button>
        <Button onClick={uploadFile} disabled={isLoading}>
          Cargar
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
